import $api from "@/core/services/ApiService";
import { AxiosRequestConfig, AxiosResponse } from "axios";

class TimelineEndpoint {
  public listEntities(
    entityClass: string,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.get(`a/timeline/${entityClass}`, { params });
  }

  public listEntityClasses(
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.get(`a/timeline/entity-classes`, { params });
  }

  public viewEntity(
    entityClass: string,
    id: string | number,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.get(`a/timeline/${entityClass}/${id}`, params);
  }

  public entityTimelineList(
    entityClass: string,
    id: string | number,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.get(`a/timeline/${entityClass}/${id}/timeline`, params);
  }

  public pullTimeline(
    entityClass: string,
    id: string | number,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.post(`a/timeline/${entityClass}/${id}/timeline`, params);
  }
}

export default TimelineEndpoint;
